module.exports = __webpack_public_path__ + "img/withdraw.d07b3107.svg";